



























import Vue from "vue";
import AdminUserItem from "@/components/Admin/AdminUserItem.vue";
import { UserI } from "vue/types/vue";
import { AdminService } from "../../services";
export default Vue.extend({
  components: {
    AdminUserItem
  },
  data() {
    return {
      users: new Array<UserI>(),
      showConfirm: false,
      selectedUser: {} as UserI,
      confirmData: "",
      modalHeader: "",
      modalMessage: ""
    };
  },
  async created() {
    this.getAllUsers();
  },
  methods: {
    getAllUsers: async function (): Promise<void> {
      const response = await AdminService.getAllUsers();

      this.users = []; //new Array<User>();

      this.users = response;
    },
    confirmDelete: async function (confirmation: any): Promise<void> {
      this.closeModal();
      try {
        if (confirmation.choice) {
          await AdminService.deleteUser(confirmation.data);
          window.location.reload();
        }
      } catch (error: any) {
        console.log(error);
      }
    },
    deleteUser: function (user: UserI): void {
      this.confirmData = user.id;
      this.modalHeader = "Ta bort användare?";
      this.modalMessage = `Vill du verkligen ta bort användare ${user.username}?`;
    },
    closeModal: function (): void {
      this.modalHeader = "";
      this.modalMessage = "";
    }
  }
});
